
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/how-ai-can-affect-your-digital-marketing-campaigns",
      function () {
        return require("private-next-pages/blog/how-ai-can-affect-your-digital-marketing-campaigns/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/how-ai-can-affect-your-digital-marketing-campaigns"])
      });
    }
  